import { commonConfig } from "~/config/common-config";
import { isRelativeUrl } from "~/lib/shared/isRelativeUrl";

export const sanitizeRelativeUrl = (url: string): string => {
  if (isRelativeUrl(url)) {
    return url
      .replace(commonConfig.NEXT_PUBLIC_ENDIL_URL, "")
      .replace(/^\/?/, "/");
  }
  return url;
};
